/*
 OutputMapping.js component
 url match: /template/mapping/:templateId
 Displays list of fields identified in template and allows user to configure the mapping by changing
 the order/selecting/deselecting fields
*/
import { withRouter } from 'react-router-dom';
import React from 'react';
import { inject, observer } from 'mobx-react';
import { withStyles } from '@material-ui/core/styles';
import { templateStyles } from '../../Styles/templateStyles';
import Loader from 'react-loader-spinner'
import Paper from '@material-ui/core/Paper';

import Table from '@material-ui/core/Table';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import Button from '@material-ui/core/Button';
import arrayMove from 'array-move';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';
import MappingField from './MappingField';
import Checkbox from '@material-ui/core/Checkbox';
import { Scrollbars } from 'react-custom-scrollbars';

const tableHeader = [
    { name: 'Sr No.', type: 'serial', sort: 1, allowSort: false, width: '5vw' },
    { name: 'Key', type: 'userFullName', sort: 1, allowSort: true, width: '8vw' },
    { name: 'Sample Value', type: 'department', sort: 1, allowSort: true, width: '8vw' },
    { name: 'Output Header', type: 'domain', sort: 1, allowSort: true, width: '9vw' },
    { name: 'Required', type: 'required', sort: 1, allowSort: false, width: '5vw' },
]

const SortableItem = SortableElement(({ row, classes, index, handleChange, sortIndex, updateSelectAll }) =>
    <div key={row._id}   >
        <MappingField row={row} index={sortIndex} updateSelectAll={updateSelectAll}></MappingField>
    </div>
);

const SortableList = SortableContainer(({ items, classes, handleChange, updateSelectAll }) => {
    return (
        <ul>
            {items.map((value, index) => (
                <SortableItem key={`item-${index}`} row={value} sortIndex={index} classes={classes} index={index} handleChange={handleChange} updateSelectAll={updateSelectAll} />
            ))}
        </ul>
    );
});

@inject('templateStore')
@observer
class OutputMapping extends React.Component {
    state = {
        refresh: false,
        outputMapping: [],
        selectAll: false
    }

    componentDidMount() {
        this.props.templateStore.getOutputMapping(this.props.match.params['templateId'])
    }

    handleChange = (event, index, value) => {
        this.props.templateStore.updateMappingValue(index, value)
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.templateStore.outputMapping !== nextProps.outputMapping) {
            this.setState({ refresh: !this.state.refresh })
        }
    }

    componentDidUpdate(prevProps) {
        if (this.state.outputMapping.length != this.props.templateStore.outputMapping.length) {
            this.setState({
                outputMapping: this.props.templateStore.outputMapping
            })
        }
    }

    //using external component "react-sortable-hoc" to allow changing the order of the table rows by drag and drop
    renderTableContent = () => {
        const { classes } = this.props;
        const { outputMapping } = this.props.templateStore;
        return (
            <SortableList items={outputMapping} onSortEnd={this.updateArrayOrdering} classes={classes} handleChange={this.handleChange} updateSelectAll={this.updateSelectAll} />
        )
    }

    updateSelectAll = (value) => {
        if (!value)
            this.setState({ selectAll: value })
    }

    /*using external component 'array-move' to change the ordering of elements in array 
    as and when the drag and drop changes
    */
    updateArrayOrdering = ({ oldIndex, newIndex }) => {
        let a = this.props.templateStore.outputMapping.slice()
        a = arrayMove(a, oldIndex, newIndex)
        this.props.templateStore.resetOutputMappings(a)
    };

    onChangeSelectAll = (e, value) => {
        this.setState({ selectAll: value })
        this.props.templateStore.selectAllMappings(value)
    }

    renderTableHead = () => {
        const { classes } = this.props;
        const { selectAll } = this.state;
        return (
            <TableHead >
                {
                    tableHeader.map((row, index) => (
                        (
                            <TableCell className={classes.tableHeader} style={{ width: row.width }} align="left">
                                <div style={{ display: 'flex' }}>
                                    <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
                                        {row.name}

                                    </div>
                                    <div>
                                        {row.name === "Required" ?
                                            <Checkbox className={classes.checkbox}
                                                style={{ marginLeft: 0 }}
                                                checked={selectAll}
                                                onChange={(event, value) => this.onChangeSelectAll(event, value)}
                                                color="primary"
                                                inputProps={{ classes: { root: classes.checkbox } }} /> : null
                                        }
                                    </div>
                                </div>
                            </TableCell>
                        )
                    ))
                }

            </TableHead>

        )
    }

    //on click back button
    back = () => {
        this.props.templateStore.saveOutputMapping(this.props.templateStore.localId)
            .then(() => {
                this.props.history.push(`/template/${this.props.match.params['templateId']}`)
            })
    }

    //on click save
    save = () => {
        this.props.templateStore.saveOutputMapping(this.props.templateStore.localId)
            .then(() => {
                if (this.props.templateStore.saveSuccess)
                    this.props.history.push(`/template/export/${this.props.templateStore.localId}`)
            })
    }

    //on click cancel
    cancel = () => {
        this.props.history.push("/dashboard/templates")
    }

    renderOutputMappings = () => {
        const { classes } = this.props;
        return (
            <React.Fragment>
                <TableContainer style={{ height: '70vh', backgroundColor: this.props.theme.palette.dark, overflowX: 'hidden' }} elevation={0} component={Paper}>
                    <Scrollbars>
                        <Table className={classes.table} aria-label="simple table" >
                            {this.renderTableHead()}
                        </Table>
                        {this.renderTableContent()}
                    </Scrollbars>
                </TableContainer>
            </React.Fragment>

        )
    }

    render() {
        const { classes, theme } = this.props;
        const { outputMapping, inProgress, templateName } = this.props.templateStore;
        if (inProgress)
            return (
                <div className={classes.loaderDiv}><Loader height={100} width={100} color={this.props.theme.palette.blue} className={classes.loading} timeout={100000} /></div>
            )
        return (
            <Scrollbars>
                <div className={classes.mappingContainer}>
                    <div className={classes.tempName}>{templateName}</div>
                    <div className={classes.docHeader}>Output Mapping <span style={{ color: theme.palette.dullGray }}> > Save</span></div>
                    <div style={{ color: 'white' }} className='container' >
                        {outputMapping.length ? this.renderOutputMappings() : null}
                    </div>
                    <div className={classes.saveContainer}>
                        <Button variant="contained" className={classes.button} onClick={this.cancel} >Cancel </Button>
                        <Button variant="contained" className={classes.button} onClick={this.back} >Show Preview </Button>
                        {
                            inProgress ?
                                <Button variant="contained" className={classes.button} style={{ backgroundColor: theme.palette.blue }}><Loader height={30} width={30} color={this.props.theme.palette.white} /></Button> :
                                <Button variant="contained" className={classes.button} style={{ backgroundColor: theme.palette.blue }} type="submit" onClick={this.save} > Next  </Button>

                        }
                    </div>
                </div>
            </Scrollbars>
        )

    }

}
export default withStyles(templateStyles, { withTheme: true })(withRouter(OutputMapping));


